// extracted by mini-css-extract-plugin
module.exports = {"container":"_2duit2_YgaCIuT1pabLSaY","container-ingredient-non-active":"_3LfJ4SgbQ5hGeQ4JPVE5o1"};